// src/pages/NotFound.jsx

const NotFound = () => {
  return (
    <div style={{ textAlign: "center", marginTop: "50px" }}>
      <h1>404</h1>
      <h2>Page Not Found</h2>
    </div>
  );
};

export default NotFound;